import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { Quote } from 'lucide-react';

interface TestimonialSingleProps {
  quote: string;
  author: string;
  role: string;
  company: string;
  location?: string;
}

export function TestimonialSingle({
  quote = "We replaced a 20-person ops WhatsApp group with this. Nobody asks 'did you do it?' anymore.",
  author = "Priya Sharma",
  role = "Head of Operations",
  company = "RetailChain India",
  location = "Mumbai",
}: TestimonialSingleProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, scale: 0.98 }}
      animate={isInView ? { opacity: 1, scale: 1 } : {}}
      transition={{ duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] }}
      className="relative max-w-3xl mx-auto text-center px-4"
    >
      {/* Quote icon */}
      <div className="flex justify-center mb-6">
        <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
          <Quote className="w-6 h-6 text-primary" />
        </div>
      </div>

      {/* Quote text */}
      <blockquote className="text-xl sm:text-2xl md:text-3xl font-medium text-foreground leading-relaxed mb-8">
        "{quote}"
      </blockquote>

      {/* Arc divider */}
      <svg
        className="w-24 h-8 mx-auto mb-6 text-primary/30"
        viewBox="0 0 100 30"
      >
        <path
          d="M 10 25 Q 50 5 90 25"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>

      {/* Attribution */}
      <div className="text-muted-foreground">
        <p className="font-semibold text-foreground">— {author}</p>
        <p className="text-sm mt-1">
          {role}, {company}
          {location && <span className="opacity-70"> ({location})</span>}
        </p>
      </div>
    </motion.div>
  );
}
